import {useState} from 'react';
import {useDispatch} from 'react-redux';
import CompleteContentTableV4 from './CompleteContentTableV4';
import DaysContentTableV4 from './DaysContentTableV4';
import NewContentTableV4 from './NewContentTableV4';
import {HiddenBottomButtonContext} from '../../../common/context';
import useFetchTabV4 from '../../../common/hook/useFetchTabV4';
import useOnWindowScroll from '../../../common/hook/useOnWindowScroll';
import useTypedSelector from '../../../common/hook/useTypedSelector';
import {onScrollGnb} from '../../common/common';
import {HomeTabPage} from '../../common/type';
import {actions} from '../state/action';

export default function TimeTableV4() {
  const dispatch = useDispatch();
  const currentTab = useTypedSelector(
    state => state.home.secondTabs[PAGE].selected
  );
  const isNewTab = currentTab === 'new';
  const isCompleteTab = currentTab === 'complete';
  const isDaysTab = !isNewTab && !isCompleteTab;

  useFetchTabV4({
    onFetch: () => {
      isNewTab && dispatch(actions.fetchNewContents(PAGE));
      isDaysTab && dispatch(actions.fetchWeekday({day: currentTab}));
      isCompleteTab && dispatch(actions.fetchCompletedContents(PAGE));
    },
    onClear: () => dispatch(actions.initializeTimeTable(PAGE)),
    changeTab: currentTab,
  });

  const [isHiddenBottomButton, setIsHiddenBottomButton] = useState(false);
  useOnWindowScroll({
    onScroll: scrollTop => {
      onScrollGnb(scrollTop, isHide => {
        setIsHiddenBottomButton(isHide);
      });
    },
  });

  return (
    <HiddenBottomButtonContext.Provider value={isHiddenBottomButton}>
      {isNewTab && <NewContentTableV4 page={PAGE} />}
      {isDaysTab && (
        <DaysContentTableV4 page={PAGE} currentDayTab={currentTab} />
      )}
      {isCompleteTab && <CompleteContentTableV4 page={PAGE} />}
    </HiddenBottomButtonContext.Provider>
  );
}

// TODO: redux와 action에 PAGE 입력하는 코드 제거하자.
const PAGE = HomeTabPage.TimeTable;
